"use strict";

_theme.Reward = (function(){
  const modalSignin = document.getElementById("rModal");
  const modalRegister = document.getElementById("srModal");
  const modalSigninup = document.getElementById("iuModal");
  if(!modalSignin || !modalRegister || !modalSigninup) return;
  const marketingInputs = modalRegister.querySelectorAll('[name="marketing"]');
  const marketingMainInputs = modalRegister.querySelector('[name="customer[accepts_marketing]"]');
  const triggerRegisterModalBtns = document.querySelectorAll('[data-reward-signup]');
  const triggerSignInModalBtns = document.querySelectorAll('[data-reward-signin]');
  const triggerSignInUpModalBtns = document.querySelectorAll('[data-reward-signinup]');
  const modalCloseBtns = document.querySelectorAll("[data-modalclose]");
  const showRecoverPswdFormzBtn = document.querySelector('#rModal .showRecoverPasswordForm');
  const cancelrecoverPswdFormBtn = document.querySelector('#rModal .cancel_text');
  const rewardCardBtn = document.querySelector('#reward-page .reward-card:nth-child(1) a.reward-card-btn');
  const loyaltyConsentInputs = document.querySelectorAll('.join-loyalty-consent [name="rewprog"]');
  const joinLoyaltyConsentBox = document.querySelector(".join-loyalty-consent");
  // const promotionConsentBox = document.querySelector(".promotion-loyalty-consent");
  const loyaltyRegistration=document.querySelector(".loyalty-registeration");
  const normalRegistration=document.querySelector(".normal-rgistration");
  const joinLoyaltyConsentBoxRadioInputs = document.querySelectorAll(".join-loyalty-consent input[type='radio']");
  const joinLoyaltyConsentBoxHiddenInputs = document.querySelectorAll(".join-loyalty-consent input[type='hidden']");

  function init(){
    let signInModalTriggerBtn = null, signupModalTriggerBtn = null;
    triggerRegisterModalBtns.forEach(function(btn){
      btn.addEventListener("click",function (evt) {
        evt.preventDefault();
        signupModalTriggerBtn = btn;
        toggleSignUpModel(true, evt.target);
        setTimeout(function(){
          _theme.focusTrap($(modalRegister), function(){
            toggleSignUpModel();
            $(btn).focus();
          });
        }, 250);
      });
    });

    triggerSignInModalBtns.forEach(function(btn){
      btn.addEventListener("click",function (evt) {
        evt.preventDefault();
        signInModalTriggerBtn = btn;
        toggleSignInModel(true);
        document.querySelector('html').classList.add('no-scroll-html')
        setTimeout(function(){
          _theme.focusTrap($(modalSignin), function(){
            toggleSignInModel();
            $(btn).focus();
          });
        }, 250);
      });
    });

    triggerSignInUpModalBtns.forEach(function(btn){
      btn.addEventListener("click",function (evt) {
        evt.preventDefault();
        signInModalTriggerBtn = btn;
        toggleSignInUpModel(true);
        document.querySelector('html').classList.add('no-scroll-html')
        setTimeout(function(){
          _theme.focusTrap($(modalSignin), function(){
            toggleSignInUpModel();
            $(btn).focus();
          });
        }, 250);
      });
    });

    modalCloseBtns.forEach(function(closeBtn, index){
      closeBtn.addEventListener("click",function (evt) {
        evt.preventDefault();
        const isLoginModal = evt.target.classList.contains('logrClose');
        const isRegisterModal = evt.target.classList.contains('logsrClose');
        toggleSignInModel();
        toggleSignUpModel();
        toggleSignInUpModel();
        if(isLoginModal) {
          if(signInModalTriggerBtn) signInModalTriggerBtn.focus();
          else triggerSignInModalBtns[0].focus();
        }
        if(isRegisterModal) {
          if(signupModalTriggerBtn) signupModalTriggerBtn.focus();
          else triggerRegisterModalBtns[0].focus();
        }
        document.querySelector('html').classList.remove('no-scroll-html')
      });
    });

    marketingInputs.forEach(function(input){
      input.addEventListener('change', function(evt){
        var inputVal = this.value.toLowerCase().trim();
        if(inputVal === 'yes'){
          marketingMainInputs.disabled = false;
        } else {
          marketingMainInputs.disabled = true;
        }
      });
    });

    loyaltyConsentInputs.forEach(function(input){
      input.addEventListener('change', function(evt){
        var inputVal = this.value.toLowerCase().trim();
        if(inputVal === 'yes'){
          joinLoyaltyConsentBoxHiddenInputs.forEach(function(input){input.disabled = false});
        } else {
          joinLoyaltyConsentBoxHiddenInputs.forEach(function(input){input.disabled = true});
        }
      });
    });

    window.onclick = function(event) {
      if (event.target ==  modalSignin) {
        toggleSignInModel();
      }
       if (event.target ==  modalRegister) {
        toggleSignUpModel();
      }
    }

    showRecoverPswdFormzBtn && showRecoverPswdFormzBtn.addEventListener('click', function(evt){
      const loginContent = document.querySelector('#rModal .rModal-content');
      const recoverPswdContent = document.querySelector('#rModal #Rewrecover_password');
      if(loginContent) loginContent.style.display = 'none';
      if(recoverPswdContent) recoverPswdContent.style.display = 'block';
      _theme.focusTrap(jQuery('#Rewrecover_password'),function() {
        if(loginContent) loginContent.style.display = 'block';
        if(recoverPswdContent) recoverPswdContent.style.display = 'none';
      });
    });
    cancelrecoverPswdFormBtn && cancelrecoverPswdFormBtn.addEventListener('click', function(evt){
      const loginContent = document.querySelector('#rModal .rModal-content');
      const recoverPswdContent = document.querySelector('#rModal #Rewrecover_password');
      if(loginContent) loginContent.style.display = 'block';
      if(recoverPswdContent) recoverPswdContent.style.display = 'none';
      _theme.focusTrap(jQuery('#rModal .rModal-content'),function() {
        
      });
    });
    rewardCardBtn && rewardCardBtn.addEventListener('click', function(evt){
      const loginContent = document.querySelector('#rModal .rModal-content');
      const recoverPswdContent = document.querySelector('#rModal #Rewrecover_password');
      if(loginContent) loginContent.style.display = 'block';
      if(recoverPswdContent) recoverPswdContent.style.display = 'none';
    });
  }

  function toggleSignInModel(show){
    if(show){
      if(modalRegister) modalRegister.classList.remove('active');
      if(modalSignin) modalSignin.classList.add('active');
    } else {
      if(modalSignin) modalSignin.classList.remove('active');
    }
  }

  function toggleSignInUpModel(show){
    console.log('modalRegister',modalRegister)
    if(show){
      if(modalRegister) modalRegister.classList.remove('active');
      if(modalSignin) modalSignin.classList.remove('active');
      if(modalSigninup) modalSigninup.classList.add('active');
    } else {
      if(modalSigninup) modalSigninup.classList.remove('active');
    }
  }

  function toggleSignUpModel(show, target){
    let isLoyaltyRegister = target ? target.dataset.loyaltyRegister : null;
    isLoyaltyRegister = isLoyaltyRegister === '' ? true : false;

    if ( !isLoyaltyRegister ) {
      joinLoyaltyConsentBox.classList.remove("hidden");
     // promotionConsentBox.classList.remove("hidden");
      normalRegistration.classList.remove("hidden");
      loyaltyRegistration.classList.add("hidden");
      joinLoyaltyConsentBoxRadioInputs.forEach(function(input){input.disabled = false});
      joinLoyaltyConsentBoxHiddenInputs.forEach(function(input){input.disabled = true});
    } else {
      joinLoyaltyConsentBox.classList.add("hidden");
     // promotionConsentBox.classList.add("hidden");
      normalRegistration.classList.add("hidden");
      loyaltyRegistration.classList.remove("hidden");
      joinLoyaltyConsentBoxRadioInputs.forEach(function(input){input.disabled = true});
      joinLoyaltyConsentBoxHiddenInputs.forEach(function(input){input.disabled = false});
    }

    if(show){
      if(modalSignin) modalSignin.classList.remove('active');
      if(modalRegister) modalRegister.classList.add('active');
    } else {
      if(modalRegister) modalRegister.classList.remove('active');
    }
  }

  document.body.addEventListener("click", function (evt) {
    let btn = evt.target.closest("[data-reward-loyalty-register]");
    if (btn) {
      evt.preventDefault();
      toggleSignUpModel(true, evt.target);
      setTimeout(function(){
        _theme.focusTrap($(modalRegister), function(){
          toggleSignUpModel();
          $(btn).focus();
        });
      }, 250);
    }
  });

  return {init: init}
})();

window.addEventListener('DOMContentLoaded', function(event){
  if(_theme.Reward && _theme.Reward.init) _theme.Reward.init();
});